import type { MediaSourceData } from '@lumen5/luminary';
import { DynamicLevel, VideoData } from '@lumen5/luminary';

import TRANSITIONS from 'js/src/editor/standard-transitions.json';

export const SCENE_EDITOR_BASE_URL = '/editor/scene-design';
export const TEMPLATE_EDITOR_BASE_URL = '/editor/template';

export const SCENE_PROPERTIES_TAB_ID = 'scene';
export const DEFAULT_TAB_ID: string = SCENE_PROPERTIES_TAB_ID;
export const DEFAULT_ASPECT_RATIO = VideoData.LANDSCAPE_ASPECT_RATIO;

export enum QueryParams {
    Template = 'template',
    SceneDesign = 'sceneDesign',
    AspectRatio = 'aspectRatio',
    Tab = 'tab',
}

export const ALLOWED_SCENE_CATEGORIES = VideoData.ALL_CATEGORIES.filter((category) => {
    if (category === VideoData.CATEGORY_BRAND) {
        return false;
    }
    return true;
});

export const UNSAVED_CHANGES_MESSAGE = 'You have unsaved changes. Really quit?';

export const SAMPLE_MEDIA_FOR_TRANSITIONS = {
    thumbnail_url: 'https://storage.googleapis.com/lumen5-prod-images/tmpTCYllZ.jpg',
    preview_url: 'https://storage.googleapis.com/lumen5-prod-images/tmp9XP7wr.jpg',
    render_url:
        'https://storage.googleapis.com/lumen5-prod-images/photo-1542143307097-c42d1d164b81kxMdaFj9dISh.jpg',
    source: 6,
    source_id: 'OA3XvcIryXk',
    license: 'CC0',
    attribution: '',
    is_editorial: false,
    width: 5472,
    height: 3648,
    type: 'image',
    uuid: '05edac6a-3f63-493e-8c5f-ecfc738a4b1f',
    title: '',
} as MediaSourceData;

/**
 * Luminary instance on scene editor has 2 scenes and the active scene is the 2nd one i.e. index = 1
 */
export const SCENE_EDITOR_ACTIVE_SCENE_INDEX = 1;

export const COPYABLE_EDITOR_AREA = 'copyable-editor-area';
export const COPY_PASTE_ELEMENT_CLASS = {
    NORMAL_STYLE: 'copyable-normalStyle',
    HIGHLIGHT_STYLE: 'copyable-highlightStyle',
    DYNAMIC_STYLE: 'copyable-dynamicStyle',
    TEXT_ASSET_DYNAMIC_STYLE: 'copyable-textAssetDynamicStyle',
    FANCY_CAPTION_STYLE: 'copyable-fancyCaptionStyle',
};

export const COPIED_ASSET_KEY = 'copied-asset';
export const COPY_PASTE_ELEMENT_CLASS_TO_PATH_MAP = {
    [COPY_PASTE_ELEMENT_CLASS.NORMAL_STYLE]: 'normalStyle',
    [COPY_PASTE_ELEMENT_CLASS.HIGHLIGHT_STYLE]: 'highlightStyle',
    [COPY_PASTE_ELEMENT_CLASS.DYNAMIC_STYLE]: '',
    [COPY_PASTE_ELEMENT_CLASS.TEXT_ASSET_DYNAMIC_STYLE]: '',
    [COPY_PASTE_ELEMENT_CLASS.FANCY_CAPTION_STYLE]: 'normalStyle',
};

export const ALLOWED_CREATION_LEVELS_FOR_STYLES = {
    default: [DynamicLevel.object, DynamicLevel.line, DynamicLevel.word],
    normalStyle: [DynamicLevel.object, DynamicLevel.line, DynamicLevel.word],
    highlightStyle: [DynamicLevel.highlight],
};

export const ALLOWED_CANVAS_CREATION_LEVELS_FOR_STYLES = {
    default: Object.values(DynamicLevel).filter(
        (level) => level !== DynamicLevel.highlight,
    ) as DynamicLevel[],
    normalStyle: Object.values(DynamicLevel).filter(
        (level) => level !== DynamicLevel.highlight,
    ) as DynamicLevel[],
    highlightStyle: [DynamicLevel.highlight] as DynamicLevel[],
};

/**
 * These values get embedded into video data so don't change an existing value
 * without a luminary migration.
 */
export enum AssetSuffix {
    None = '',
    DisableSwap = 'disable_swap',
    Disclaimer = 'disclaimer',
    EmbeddedLogo = 'embedded_logo',
}

type StandardTransitions = {
    [key: string]: {
        [key: string]: string;
    };
};
export const STANDARD_TRANSITIONS: StandardTransitions = TRANSITIONS;

export enum VideoType {
    TOM = 'TOM',
    TH = 'TH',
    AIVO = 'AIVO',
}
